import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import classNames from 'classnames';

import {
	changeCurrentPath,
	resetMainListState,
	resetConsigneeListStateNew,
	setMappingStatus,
	delMappingInfo,
	resetMappingStatus
} from '../../../actions';


import Header from '../../../common/containers/header';
import Progress from '../../../common/containers/progress'
import SpNav from '../../../common/containers/sp_nav'
import Footer from '../../../common/containers/footer';
import MainButtons from '../../../common/components/main-buttons';
import AlertDialog from '../../../common/components/dialog/alert-dialog';
import ErrorDialog from '../../../common/components/dialog/error-dialog';
import ReloadModal from '../../../common/components/dialog/reload-dialog';
import LogoutModal from '../../../common/components/dialog/logout-dialog';


import { DndProvider } from 'react-dnd'
import Backend from 'react-dnd-html5-backend'

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import red from "@material-ui/core/colors/red";

import Stepper from '../components/stepper'
import DropTarget from './components/drop-target'
import DragTarget from './components/drag-target'

import {getValueHash} from "../../../common/utils/array";





const styles = theme => ({
	listTitle :{

	},
	root: {
		flexGrow: 1,
	},
	cautionText:{
		marginBottom:30,
		padding:10,
		borderTop:'rgba(0,0,0,0.05) solid 5px',
		borderBottom:'rgba(0,0,0,0.05) solid 5px',
		fontSize : '85%'
	},
	cautionAddText:{
		color:red[800]
	},
	paper:{
		maxHeight:'calc(100vh - 500px)',
		overflowY:'scroll'
	},
	templateName:{
		marginBottom: 20
	},
	templateNameNone:{
		marginBottom: 20,
		'& fieldset':{
			borderColor:'#40bad0 !important'
		},
		'& label':{
			color:'rgb(44,130,145) !important'
		}
	},
	captions:{
		marginLeft:15,
		color:'#c62828',
		fontSize: '80%'
	},

});

class MappingStep2 extends Component {

	constructor(props) {
		super(props);
		const processDivide = !("divide" in props.match.params) || !props.match.params.divide ? "1" : props.match.params.divide;
		this.state = {
			dropData:props.settings.target,
			dragData:props.settings.source,
			templateName : props.settings.templateName,
			copyDialogOpen : false,
			deleteDialogOpen : false,
			processDivide
		}
	}
	/** override methods **/
	UNSAFE_componentWillMount() {
		const {dispatch} = this.props;
		dispatch(resetMainListState());
		dispatch(resetConsigneeListStateNew());
	}

	UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
		if(nextProps.settings.isProcessComplete){
			this.props.dispatch(resetMappingStatus());
			this.props.history.push('/mapping/step1/'+this.state.processDivide);
		}
	}

	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}

	/** event handlers **/
	handleAcceptDrop = (drag, drop) =>{
		let dropData = getValueHash(this.state.dropData);
		const targetIndex = _.findIndex(dropData,['value',drop]);

		if(dropData[targetIndex].relation.indexOf(drag) === -1){
			dropData[targetIndex].relation.push(drag);
		}
		dropData[targetIndex].checked = true;

		this.setState({
			dropData
		})
	};

	handleLinkOff = (drop_name) =>{
		let dropData = getValueHash(this.state.dropData);
		const targetIndex = _.findIndex(dropData,['value',drop_name]);
		dropData[targetIndex].relation = [];
		dropData[targetIndex].conversion = [];
		dropData[targetIndex].fixValue = null;
		dropData[targetIndex].defaultValue = null;
		dropData[targetIndex].checked = false;

		this.setState({
			dropData
		})
	};

	handleCheckChange = (data) =>{
		let dropData = getValueHash(this.state.dropData);
		const targetIndex = _.findIndex(dropData,['value',data.value]);

		if(data.relation.length > 0){
			return
		}

		dropData[targetIndex].relation = [];
		dropData[targetIndex].conversion = [];
		dropData[targetIndex].fixValue = null;
		dropData[targetIndex].defaultValue = null;
		dropData[targetIndex].checked = !(dropData[targetIndex].checked);


		this.setState({
			dropData
		})
	};

	handleClickNext = ()=>{
		const {dropData,templateName} = this.state;
		const {history, dispatch} = this.props;
		dispatch(setMappingStatus({
			target:dropData,
			templateName
		}));

		history.push('/mapping/step3/'+this.state.processDivide);
	};

	handleClickBack = ()=>{
		this.props.history.push('/mapping/step1/'+this.state.processDivide);
	};

	handleClickCopy = ()=>{
		this.setState({
			copyDialogOpen : true
		})
	};

	handleClickDelete = ()=>{
		this.setState({
			deleteDialogOpen : true
		})
	};

	handleChangeTemplateName = (event) =>{
		this.setState({
			templateName : event.target.value
		});
	};


	doCopy = () =>{
		this.setState({
			copyDialogOpen : false,
			templateName : this.state.templateName + '(コピー)'
		});
		this.props.dispatch(setMappingStatus({
			templateID : null
		}));
	};

	doDelete = () =>{
		const {dispatch, settings, auth} = this.props;
		this.setState({
			deleteDialogOpen : false
		});

		dispatch(delMappingInfo({
			SessionID : auth.SessionID,
			templateID : settings.templateID,
			processDivide:this.state.processDivide
		}));

	};
	cancelDelete = () =>{
		this.setState({
			deleteDialogOpen : false
		})
	};

	handleClickBackList = () =>{
		if(this.state.processDivide === "1"){
			this.props.history.push('/main-list');
		}
		else{
			this.props.history.push('/shipment');
		}

	};

	handleClickBackUpload = () =>{
		this.props.history.push('/upload/'+this.state.processDivide);
	};



	render() {
		const {classes,settings,history} = this.props;
		const {isFetching, isProcessError} = settings;
		const {dropData, dragData, templateName, copyDialogOpen, deleteDialogOpen,processDivide} = this.state;

		const useDrag = [];
		dropData.forEach((drop)=>{
			drop.relation.forEach((rel)=>{
				useDrag.push(rel);
			})
		});

		const isNewTemplate = (settings.templateID === null) ? true : false;
		const filters = dropData.filter(function(drops) {
			return (drops.isRequired && !drops.checked)
		});
		const isNextDeisabled = (filters.length > 0);

		const mainButtons = [
			{type:'NEXT',func:this.handleClickNext,text:"次へ",disabled:isNextDeisabled},
			{type:'BACK',func:this.handleClickBack,text:"前へ"},
			{type:'COPY',func:this.handleClickCopy,disabled:isNewTemplate,text:"複写",hasMargin:true},
			{type:'DELETE',func:this.handleClickDelete,disabled:isNewTemplate}
		];

		const navigations = [
			{name:processDivide === "2" ? '車番登録' : '一覧',clickFunc:this.handleClickBackList},
			{name:(processDivide === "2" ? '車番情報' : '') + 'CSVアップロード',clickFunc:this.handleClickBackUpload}
		];


		const isTemplateNameBlank = !templateName ? true : false;


		return (
			<div id="main_container">
				{(isFetching) &&
				<Progress/>
				}
				<SpNav history={history}/>
				<Header history={history} navigations={navigations} />
				<article>
					<section className="title_area">
						<h2>テンプレートマッピング</h2>
					</section>
					<section className="with_button">
						<TextField
							label="テンプレート名"
							placeholder="テンプレート名を入力してください"
							className={classNames(isTemplateNameBlank ? classes.templateNameNone : classes.templateName)}
							value={templateName}
							fullWidth
							variant="outlined"
							onChange={this.handleChangeTemplateName}
							InputLabelProps={{
								shrink:true,
							}}
						/>
						<Stepper activeStep={1}/>
						<p className={classes.cautionText}>
							選択項目一覧から対象を選択し、設定項目へドラッグアンドドロップで紐付けをおこなってください<br/>
							<span className={classes.cautionAddText}>※紐付けは行わずに固定値を設定したい場合は、設定項目にチェックをつけてください</span>
						</p>

					</section>
					<section className="with_button">
						<DndProvider backend={Backend}>
							<Grid container className={classes.root} spacing={32}>
								<Grid item xs={6}>
									<Typography>選択項目</Typography>
									<Paper className={classes.paper}>
										{dragData.map((data,index)=>{
											const isLast = dragData.length - 1 === index;
											const isUse = (useDrag.indexOf(data) >= 0) ? true : false;

											return([
												<DragTarget
													data={data}
													func={this.handleAcceptDrop}
													key={"box" + index}
													isUse={isUse}
												/>,
												(!isLast && <Divider key={"divider" + index} />)
											]);
										})}
									</Paper>
								</Grid>
								<Grid item xs={6}>
									<Typography>
										設定項目
										<span className={classes.captions}>設定項目と伝票への印字については、各レイアウト仕様書をご参考下さい。</span>
									</Typography>
									<Paper className={classes.paper}>
										{dropData.map((data,index)=>{
											const isLast = dropData.length === index;
											return([
												<DropTarget
													data={data}
													key={"box" + index}
													offFunc={this.handleLinkOff}
													checkChangeFunc={this.handleCheckChange}
												/>,
												(!isLast && <Divider key={"divider" + index} />)
											]);
										})}
									</Paper>
								</Grid>
							</Grid>
						</DndProvider>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<ErrorDialog
					open={isProcessError}
				/>
				<ErrorDialog
					open={copyDialogOpen}
					title={'ご案内'}
					text={<span>現在選択中のテンプレート情報から新しいテンプレートを作成します。</span>}
					afterCloseFunc={this.doCopy}
				/>
				<AlertDialog
					open={deleteDialogOpen}
					title={"確認"}
					text={<span>テンプレートを削除します。よろしいですか？</span>}
					okFunction={this.doDelete}
					closeFunction={this.cancelDelete}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.mappingSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(MappingStep2);




// WEBPACK FOOTER //
// ./src/routes/mapping/step2/index.js